import classNames from 'classnames';
import { get } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import routes from '../../../app/routes';
import { FAIcon } from '../../../components/adapters/fontAwesomeAdapters';
import { isMenuItemActive, useActiveRoute } from '../../../utils/routeUtils';
import { useAdminConsoleTabsStyles } from './AdminConsoleTabs.styles';

const TABS = [
  {
    to: routes.admin.accountManagement,
    labelId: 'admin.menu.accountManagement',
    icon: 'building',
  },
  {
    to: routes.admin.legacy.userManagement,
    labelId: 'admin.menu.userManagement',
    icon: 'users',
  },
];

export default function AdminConsoleTabs() {
  const { styles } = useAdminConsoleTabsStyles();
  const activeRoute = get(useActiveRoute(TABS), 'to');
  const activeTab =
    TABS.find(tab => isMenuItemActive(activeRoute, { to: tab.to })) || TABS[0];

  return (
    <div className={styles.tabs}>
      <div className={styles.section}>
        <FAIcon icon={activeTab.icon} className={styles.sectionIcon} />
        <span>
          <FormattedMessage id={activeTab.labelId} />
        </span>
      </div>
      <div className={styles.links}>
        {TABS.map(tab => {
          const active = tab === activeTab;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={classNames(styles.link, { active })}
            >
              <FormattedMessage id={tab.labelId} />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
